import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NftBid from "./NftBid";
import NftBuyNow from "./NftBuyNow";
import "../../style/Nftpage.css";
import { BiHeart } from "react-icons/bi";
import Slider from "react-slick";
function NftdetailPage() {
  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    // variableWidth: true,

    responsive: [
      {
        breakpoint: 1600,
        settings: {
          centerMode: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          centerMode: false,
          slidesToShow: 2.8,
        },
      },
      {
        breakpoint: 844,
        settings: {
          centerMode: false,
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 700,
        settings: {
          centerMode: false,
          slidesToShow: 1.45,
        },
      },
      {
        breakpoint: 526,
        settings: {
          centerMode: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 450,
        settings: {
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };
  const location = useLocation();
  const profileDetails = location?.state?.page;
  const type = location?.state?.type;
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <section>
      <div className="mainContainer">
        <div className="pt-5">
          {location.state.type === "buy" ? (
            <NftBuyNow profileDetails={profileDetails} type={type} />
          ) : (
            <NftBid profileDetails={profileDetails} type={type} />
          )}
        </div>
        <div className="offer1">
          <h6>offers (1)</h6>
          <div className="pricesOffer">
            <div className="priceEth">
              <p>price</p>
              <h6>16.5 ETH</h6>
            </div>
            <div className="expireAt">
              <p>Expires At</p>
              <h6></h6>
            </div>
            <div className="fomUser">
              <p>From</p>
              <h6>4PS45wiXeR6EJVrhJTCvxCY8rZLKLYPXnCioKSs4bv7P</h6>
            </div>
          </div>
        </div>
        <div className="purchaseActivity">
          <h6>Activities</h6>
          <div>
            <div className="labelDetails">
              <span className="spaceMaker"></span>
              <h6 className="nameInTable">name</h6>
              <h6 className="transactionTable">transaction id</h6>
              <h6 className="typeTable">transaction type</h6>
              <h6 className="timeTable">time</h6>
              <h6 className="amountTable">total amount</h6>
              <h6 className="buyerTable">buyer</h6>
              <h6 className="sellerTable">seller</h6>
            </div>
            <div className="transationDetails">
              <div className="nftImg spaceMaker">
                <img src="image 61.png" alt="nft" />
              </div>
              <h6 className="nameDetails nameInTable">Primate #3728</h6>
              <p className="transactionTable">3AwQu...nu6</p>
              <p className="typeTable">
                <span className="listing">
                  Listing <span className="colorList">(ME V2)</span>
                </span>
              </p>
              <p className="timeTable">13 min ago</p>
              <p className="amountTable">30 ETH</p>
              <p className="buyerTable"></p>
              <p className="sellerTable">CyDFr...KXD</p>
            </div>
            <div className="transationDetails">
              <div className="nftImg spaceMaker">
                <img src="image 61.png" alt="nft" />
              </div>
              <h6 className="nameDetails nameInTable">Primate #3728</h6>
              <p className="transactionTable">3AwQu...nu6</p>
              <p className="typeTable">
                <span className="listing">
                  <span className="placeBid">Place Bid</span>
                  <span className="colorList">(ME V2)</span>
                </span>
              </p>
              <p className="timeTable">13 min ago</p>
              <p className="amountTable">30 ETH</p>
              <p className="buyerTable">CyDFr...KXD</p>
              <p className="sellerTable"></p>
            </div>
            <div className="transationDetails">
              <div className="nftImg spaceMaker">
                <img src="image 61.png" alt="nft" />
              </div>
              <h6 className="nameDetails nameInTable">Primate #3728</h6>
              <p className="transactionTable">3AwQu...nu6</p>
              <p className="typeTable">
                <span className="listing">
                  <span className="settingList">Cancel Listing</span>
                  <span className="colorList">(ME V2)</span>
                </span>
              </p>
              <p className="timeTable">13 min ago</p>
              <p className="amountTable">30 ETH</p>
              <p className="buyerTable"></p>
              <p className="sellerTable">CyDFr...KXD</p>
            </div>
            <div className="transationDetails">
              <div className="nftImg spaceMaker">
                <img src="image 61.png" alt="nft" />
              </div>
              <h6 className="nameDetails nameInTable">Primate #3728</h6>
              <p className="transactionTable">3AwQu...nu6</p>
              <p className="typeTable">
                <span className="listing">
                  Listing <span className="colorList">(ME V2)</span>
                </span>
              </p>
              <p className="timeTable">13 min ago</p>
              <p className="amountTable">30 ETH</p>
              <p className="buyerTable"></p>
              <p className="sellerTable">CyDFr...KXD</p>
            </div>
            <div className="transationDetails">
              <div className="nftImg spaceMaker">
                <img src="image 61.png" alt="nft" />
              </div>
              <h6 className="nameDetails nameInTable">Primate #3728</h6>
              <p className="transactionTable">3AwQu...nu6</p>
              <p className="typeTable">
                <span className="listing">
                  <span className="placeBid">Place Bid</span>
                  <span className="colorList">(ME V2)</span>
                </span>
              </p>
              <p className="timeTable">13 min ago</p>
              <p className="amountTable">30 ETH</p>
              <p className="buyerTable">CyDFr...KXD</p>
              <p className="sellerTable"></p>
            </div>
            <div className="transationDetails">
              <div className="nftImg spaceMaker">
                <img src="image 61.png" alt="nft" />
              </div>
              <h6 className="nameDetails nameInTable">Primate #3728</h6>
              <p className="transactionTable">3AwQu...nu6</p>
              <p className="typeTable">
                <span className="listing">
                  <span className="settingList">Cancel Listing</span>
                  <span className="colorList">(ME V2)</span>
                </span>
              </p>
              <p className="timeTable">13 min ago</p>
              <p className="amountTable">30 ETH</p>
              <p className="buyerTable"></p>
              <p className="sellerTable">CyDFr...KXD</p>
            </div>
          </div>
        </div>
        <div className="FromCollection">
          <h6>More from this collection</h6>
          <Slider {...settings}>
            <div className="artistCollectionsList">
              <div className="artistLists">
                <img
                  src={profileDetails.mainImg}
                  alt="creation"
                  className="mainImgs"
                />
                <div className="heartLikes">
                  <BiHeart /> <span className="ms-2">5</span>
                </div>
              </div>
              <h5 className="pt-4 d-flex align-items-center">
                {profileDetails.profileName}
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </h5>
              <p className="numberCards pt-1">
                {profileDetails.profileName} #234
              </p>
              <div className="priceonCollection">
                <div className="d-flex opacity-50 bidss">
                  <div className="w-50 ">Price</div>
                  <div>Highest bid</div>
                </div>
                <div className="d-flex bidandAMounts ">
                  <div className="w-50 ">16.5 ETH</div>
                  <div>10.5 ETH</div>
                </div>
              </div>

              <button className="mt-3 buysNowandbid">Place a bid</button>
            </div>
            <div className="artistCollectionsList">
              <div className="artistLists">
                <img
                  src="image 32 (10).png"
                  alt="creation"
                  className="mainImgs"
                />
                <div className="heartLikes">
                  <BiHeart /> <span className="ms-2">5</span>
                </div>
              </div>
              <h5 className="pt-4 d-flex align-items-center">
                {profileDetails.profileName}
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </h5>
              <p className="numberCards pt-1">
                {profileDetails.profileName} #234
              </p>
              <div className="priceonCollection">
                <div className="d-flex opacity-50 bidss">
                  <div className="w-50 ">Price</div>
                  <div>Highest bid</div>
                </div>
                <div className="d-flex bidandAMounts ">
                  <div className="w-50 ">16.5 ETH</div>
                  <div>10.5 ETH</div>
                </div>
              </div>

              <button className="mt-3 buysNowandbid">Place a bid</button>
            </div>
            <div className="artistCollectionsList">
              <div className="artistLists">
                <img
                  src="image 32 (12).png"
                  alt="creation"
                  className="mainImgs"
                />
                <div className="heartLikes">
                  <BiHeart /> <span className="ms-2">5</span>
                </div>
              </div>
              <h5 className="pt-4 d-flex align-items-center">
                {profileDetails.profileName}
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </h5>
              <p className="numberCards pt-1">
                {profileDetails.profileName} #234
              </p>
              <div className="priceonCollection">
                <div className="d-flex opacity-50 bidss">
                  <div className="w-50 ">Price</div>
                  <div>Highest bid</div>
                </div>
                <div className="d-flex bidandAMounts ">
                  <div className="w-50 ">16.5 ETH</div>
                  <div>10.5 ETH</div>
                </div>
              </div>

              <button className="mt-3 buysNowandbid">Place a bid</button>
            </div>
            <div className="artistCollectionsList">
              <div className="artistLists">
                <img
                  src="image 32 (14).png"
                  alt="creation"
                  className="mainImgs"
                />
                <div className="heartLikes">
                  <BiHeart /> <span className="ms-2">5</span>
                </div>
              </div>
              <h5 className="pt-4 d-flex align-items-center">
                {profileDetails.profileName}
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </h5>
              <p className="numberCards pt-1">
                {profileDetails.profileName} #234
              </p>
              <div className="priceonCollection">
                <div className="d-flex opacity-50 bidss">
                  <div className="w-50 ">Price</div>
                  <div>Highest bid</div>
                </div>
                <div className="d-flex bidandAMounts ">
                  <div className="w-50 ">16.5 ETH</div>
                  <div>10.5 ETH</div>
                </div>
              </div>

              <button className="mt-3 buysNowandbid">Place a bid</button>
            </div>
            <div className="artistCollectionsList">
              <div className="artistLists">
                <img
                  src="image 32 (15).png"
                  alt="creation"
                  className="mainImgs"
                />
                <div className="heartLikes">
                  <BiHeart /> <span className="ms-2">5</span>
                </div>
              </div>
              <h5 className="pt-4 d-flex align-items-center">
                {profileDetails.profileName}
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </h5>
              <p className="numberCards pt-1">
                {profileDetails.profileName} #234
              </p>
              <div className="priceonCollection">
                <div className="d-flex opacity-50 bidss">
                  <div className="w-50 ">Price</div>
                  <div>Highest bid</div>
                </div>
                <div className="d-flex bidandAMounts ">
                  <div className="w-50 ">16.5 ETH</div>
                  <div>10.5 ETH</div>
                </div>
              </div>

              <button className="mt-3 buysNowandbid">Place a bid</button>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default NftdetailPage;
